

import { createUseStyles } from 'react-jss';

var styles = {
  tableRow: function tableRow(props) {return {
      display: 'table',
      width: '100%',
      tableLayout: 'fixed',
      cursor: props.onClick && 'pointer'
    };}
};

var createStyles = createUseStyles(styles);

export { createStyles };
//# sourceMappingURL=styles.js.map